const projects = [
  {
    image: "https://clwizard.com/wp-content/uploads/2022/06/Blushot-Concrete-Leak-Specialist10.png",
    tag: "Parking Garage",
    title: "Underground infiltration sealed in 48hrs",
    desc: "Multi-level underground parking structure with severe hydrostatic pressure. Treated without closing a single parking level. Dry within 48 hours.",
    stat: "48hrs",
    statLabel: "Complete Resolution",
  },
  {
    image: "https://clwizard.com/wp-content/uploads/2022/06/Blushot-Concrete-Leak-Specialist11.png",
    tag: "Hotel Facade",
    title: "Treated without closing a single room",
    desc: "12-story hotel facade with water infiltration through expansion joints. Full treatment completed while hotel remained at 100% occupancy.",
    stat: "0",
    statLabel: "Rooms Closed",
  },
  {
    image: "https://clwizard.com/wp-content/uploads/2022/06/Blushot-Concrete-Leak-Specialist12.png",
    tag: "Condominium Lobby",
    title: "Dry after first rainfall. Zero complaints.",
    desc: "Luxury condominium lobby with recurring water infiltration through the slab. Treated in one day. Dry after the very first rainfall. Zero resident complaints.",
    stat: "1st",
    statLabel: "Rainfall — Dry",
  },
];

export default function BeforeAfterSection() {
  return (
    <section id="projects" className="bg-[#0a0e1a] py-20 md:py-28">
      <div className="max-w-6xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#4a7fa5] font-bold uppercase tracking-widest text-sm mb-3">Before &amp; After</p>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-white max-w-3xl mx-auto leading-tight">
            The Same Problem. Two Different Approaches.{" "}
            <span className="text-[#4a7fa5]">One Permanent Result.</span>
          </h2>
        </div>

        {/* Project cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {projects.map((project) => (
            <div
              key={project.title}
              className="bg-[#0f1525] border border-white/10 rounded-lg overflow-hidden hover:border-[#1a3a5c]/60 transition-colors group"
            >
              {/* Image */}
              <div className="w-full h-52 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-6">
                <span className="inline-block bg-[#1a3a5c]/30 text-[#8ab4cc] text-xs font-bold px-3 py-1 rounded-full mb-3">
                  {project.tag}
                </span>
                <h3 className="text-white font-bold text-base mb-2 leading-snug">{project.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed mb-5">{project.desc}</p>

                {/* Stat */}
                <div className="flex items-end gap-2 border-t border-white/10 pt-4">
                  <span className="text-3xl font-black text-[#4a7fa5]">{project.stat}</span>
                  <span className="text-gray-400 text-xs font-semibold pb-1">{project.statLabel}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
